import fetch from './fetch';

const url = '/notice';
// 新增消息
const fetchNoticeCreate = params => fetch({ url, params, methold: 'post' });
// 消息列表
const fetchNoticeList = params => fetch({ url, params, methold: 'get' });
// 修改
const fetchNoticeUpdate = data => {
  const { id, ...params } = data;
  return fetch({ url: `${url}/${id}`, params, methold: 'put' });
};
// 删除
const fetchNoticeDelete = id => fetch({ url: `${url}/${id}`, methold: 'delete' });

// 启用禁用
const fetchNoticeUpdateState = id => fetch({ url: `ban_notice/${id}` });

// 查看通知
const fetchNoticeDetails = id => fetch({ url: `notice_category/${id}` });
// 根据是否已读查询
const fetchNoticeListByIsConfirm = data => {
  const { id, ...params } = data;
  return fetch({ url: `notice_get_confirm_detail/${id}`, params });
};

export default {
  fetchNoticeCreate,
  fetchNoticeList,
  fetchNoticeDelete,
  fetchNoticeUpdate,
  fetchNoticeDetails,
  fetchNoticeListByIsConfirm,
  fetchNoticeUpdateState
};
